import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from '@material-ui/core';

const Markdown = ({
  content,
  allowedTypes = [
    'root',
    'text',
    'strong',
    'emphasis',
    'link',
    'image',
    'paragraph',
    'break',
    'list',
    'listItem'
  ]
}) => {
  let normalizedContent = content;
  if (content && typeof content === 'string') {
    normalizedContent = content.replace(
      /\n+/g,
      // single linebreaks should also make a <p>, which needs two linebreaks
      '\n\n'
    );
  }
  if (!allowedTypes.includes('listItem') && normalizedContent.match(/^(\d+)\.(\s+)(\S+)/)) {
    normalizedContent = normalizedContent.replace(/^(\d+)\.(\s+)(\S+)/, '$1.&nbsp;$3')
  }
  return (
    <ReactMarkdown
      source={normalizedContent}
      unwrapDisallowed
      renderers={{ link: Link }}
      allowedTypes={allowedTypes}
      linkTarget="_blank"
    />
  );
};

export default React.memo(Markdown);
